// outstationTripsData.js
export const outstationTripsData = {
  "ramoji-film-city": {
    title: "Hyderabad to Ramoji Film City",
    distance: "35 km",
    duration: "~1 hr by road",
    images: [
      "https://www.gokitetours.com/wp-content/uploads/2024/04/Things-to-Do-at-Ramoji-Film-City-in-Hyderabad.webp",
      "https://www.oyorooms.com/blog/wp-content/uploads/2019/06/Ramoji-Film-City-1.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlEbLpCAeqlxM9AU64hYE0XEqAuw6bAMWRYg&s",
    ],
    vehicles: [
      { type: "Sedan", price: "₹12/km", image: "https://acecabs.in/cars/sedan/Honda-Amaze.png" },
      { type: "SUV", price: "₹16/km", image: "https://indorecabservice.com/wp-content/uploads/2022/03/maruti-ertiga-sport-small-removebg-preview.png" },
      { type: "Tempo Traveller", price: "₹22/km", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJIT1TTdA0jjKVtha6svcmP3ck8cu4xPIOhSxVdfzhVzQxF152G7B0NJXxFr_SEFMRpJM&usqp=CAU" }
    ],
    itinerary: [
      { day: "Day 1", detail: "Pickup from Hyderabad and drive to Ramoji Film City" },
      { day: "Day 1", detail: "Enjoy guided tour of attractions, sets, and shows" },
      { day: "Evening", detail: "Return to Hyderabad" },
    ],
    highlights: [
      "✔️ World’s largest film city experience",
      "✔️ Comfortable AC transport",
      "✔️ Flexible pickup from Hyderabad",
    ],
  },

  "charminar": {
    title: "Hyderabad to Charminar",
    distance: "10 km",
    duration: "~30 min by road",
    images: [
      "https://indiainfrahub.com/wp-content/uploads/2020/08/Charminar.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9QsqzOn0G9rVl6PloTJ2DISm-jbO4MDnpDSNbawFzf_wZ0LrozdlnvVSLvwwKtIziOQ8&usqp=CAU",
      "https://s7ap1.scene7.com/is/image/incredibleindia/charminar-mosque-hyderabad-telangana-3-attr-about?qlt=82&ts=1742173420954"
    ],
    vehicles: [
      { type: "Sedan", price: "₹12/km", image: "https://acecabs.in/cars/sedan/Honda-Amaze.png" },
      { type: "SUV", price: "₹16/km", image: "https://indorecabservice.com/wp-content/uploads/2022/03/maruti-ertiga-sport-small-removebg-preview.png" },
      { type: "Tempo Traveller", price: "₹22/km", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJIT1TTdA0jjKVtha6svcmP3ck8cu4xPIOhSxVdfzhVzQxF152G7B0NJXxFr_SEFMRpJM&usqp=CAU" }
    ],
    itinerary: [
      { day: "Day 1", detail: "Visit Charminar, shop at Laad Bazaar" },
      { day: "Day 1", detail: "Explore nearby Mecca Masjid" },
    ],
    highlights: [
      "✔️ Quick city heritage trip",
      "✔️ Perfect for evenings",
      "✔️ Local guide available",
    ],
  },

  "goa": {
    title: "Hyderabad to Goa",
    distance: "660 km",
    duration: "~12 hrs by road",
    images: [
      "https://assets-news.housing.com/news/wp-content/uploads/2022/08/01072310/Goa-feature-compressed.jpg",
      "https://images.hindustantimes.com/rf/image_size_960x540/HT/p2/2018/08/16/Pictures/_dbca9ffa-a138-11e8-9345-8d51f8ed9678.jpg",
      "https://s7ap1.scene7.com/is/image/incredibleindia/1-palolem-beach-goa-goa-city-hero?qlt=82&ts=1742182084999"
    ],
    vehicles: [
      { type: "Sedan", price: "₹12/km", image: "https://acecabs.in/cars/sedan/Honda-Amaze.png" },
      { type: "SUV", price: "₹16/km", image: "https://indorecabservice.com/wp-content/uploads/2022/03/maruti-ertiga-sport-small-removebg-preview.png" },
      { type: "Tempo Traveller", price: "₹22/km", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJIT1TTdA0jjKVtha6svcmP3ck8cu4xPIOhSxVdfzhVzQxF152G7B0NJXxFr_SEFMRpJM&usqp=CAU" }
    ],
    itinerary: [
      { day: "Day 1", detail: "Depart from Hyderabad at night" },
      { day: "Day 2", detail: "Arrival in Goa, explore Baga & Calangute Beach" },
      { day: "Day 3", detail: "Visit Old Goa Churches & Aguada Fort" },
      { day: "Day 4", detail: "Leisure, shopping, and return to Hyderabad" },
    ],
    highlights: [
      "✔️ Comfortable vehicles with AC",
      "✔️ Professional drivers",
      "✔️ Toll & driver charges included",
    ],
  },

  "golconda-fort": {
    title: "Hyderabad to Golconda Fort",
    distance: "11 km",
    duration: "~40 min by road",
    images: [
      "https://s7ap1.scene7.com/is/image/incredibleindia/golconda-fort-hyderabad-secunderabad-telangana-3-musthead-hero?qlt=82&ts=1742197014098",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwUI6cpFDBrP66A0ozDgeQwofDB2irdmkxsg&s",
      "https://s7ap1.scene7.com/is/image/incredibleindia/golconda-fort-hyderabad-secunderabad-telangana-1-musthead-hero?qlt=82&ts=1742170130583",
    ],
    vehicles: [
      { type: "Sedan", price: "₹12/km", image: "https://acecabs.in/cars/sedan/Honda-Amaze.png" },
      { type: "SUV", price: "₹16/km", image: "https://indorecabservice.com/wp-content/uploads/2022/03/maruti-ertiga-sport-small-removebg-preview.png" },
      { type: "Tempo Traveller", price: "₹22/km", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJIT1TTdA0jjKVtha6svcmP3ck8cu4xPIOhSxVdfzhVzQxF152G7B0NJXxFr_SEFMRpJM&usqp=CAU" }
    ],
    itinerary: [
      { day: "Day 1", detail: "Pickup from Hyderabad and visit Golconda Fort" },
      { day: "Day 1", detail: "Evening light and sound show" },
    ],
    highlights: [
      "✔️ Historical fort with guided tour",
      "✔️ Perfect for evening trips",
    ],
  },

  "warangal": {
    title: "Hyderabad to Warangal",
    distance: "150 km",
    duration: "~3 hrs by road",
    images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSIAvNtW1X9fWODnzDKQHAw3IkFCZL9VHFy-w&s",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTET8-d68nZhS7TlsRf7XQyJINk8T1HElTHMQ&s",
      "https://static.toiimg.com/photo/59593180.cms"
    ],
    vehicles: [
      { type: "Sedan", price: "₹12/km", image: "https://acecabs.in/cars/sedan/Honda-Amaze.png" },
      { type: "SUV", price: "₹16/km", image: "https://indorecabservice.com/wp-content/uploads/2022/03/maruti-ertiga-sport-small-removebg-preview.png" },
      { type: "Tempo Traveller", price: "₹22/km", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJIT1TTdA0jjKVtha6svcmP3ck8cu4xPIOhSxVdfzhVzQxF152G7B0NJXxFr_SEFMRpJM&usqp=CAU" }
    ],
    itinerary: [
      { day: "Day 1", detail: "Pickup from Hyderabad and drive to Warangal" },
      { day: "Day 1", detail: "Explore Warangal Fort & Thousand Pillar Temple" },
      { day: "Evening", detail: "Return to Hyderabad" },
    ],
    highlights: [
      "✔️ Heritage city experience",
      "✔️ Comfortable transport",
    ],
  },

  "nagarjuna-sagar": {
    title: "Hyderabad to Nagarjuna Sagar",
    distance: "165 km",
    duration: "~3.5 hrs by road",
    images: [
      "https://s7ap1.scene7.com/is/image/incredibleindia/nagarjuna-sagar-dam-hyderabad-telangana-1-musthead-hero?qlt=82&ts=1742170278837",
    "https://s7ap1.scene7.com/is/image/incredibleindia/nagarjuna-sagar-dam-hyderabad-telangana-1-attr-hero?qlt=82&ts=1742157716450",
    "https://cdn.siasat.com/wp-content/uploads/2025/08/nagarjuna-sagar.jpg"
    ],
    vehicles: [
      { type: "Sedan", price: "₹12/km", image: "https://acecabs.in/cars/sedan/Honda-Amaze.png" },
      { type: "SUV", price: "₹16/km", image: "https://indorecabservice.com/wp-content/uploads/2022/03/maruti-ertiga-sport-small-removebg-preview.png" },
      { type: "Tempo Traveller", price: "₹22/km", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJIT1TTdA0jjKVtha6svcmP3ck8cu4xPIOhSxVdfzhVzQxF152G7B0NJXxFr_SEFMRpJM&usqp=CAU" }
    ],
    itinerary: [
      { day: "Day 1", detail: "Pickup from Hyderabad and drive to Nagarjuna Sagar" },
      { day: "Day 1", detail: "Visit dam, museum, and waterfalls (seasonal)" },
      { day: "Evening", detail: "Return to Hyderabad" },
    ],
    highlights: [
      "✔️ Scenic water reservoir",
      "✔️ Ideal weekend getaway",
    ],
  },

  "vijayawada": {
    title: "Hyderabad to Vijayawada",
    distance: "275 km",
    duration: "~5 hrs by road",
    images: [
      "https://www.abhibus.com/blog/wp-content/uploads/2023/09/Things-to-Do-in-Vijayawada-for-a-Quick-Getaway.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQrA3tqfuhtUWmiOVHLCKN7WvnNzsL7GA2D0KRcEOUK_KeunrV1FZDgzw4NN8txIYmOqZM&usqp=CAU",
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0f/b5/db/4f/prakasam-barrage.jpg?w=1400&h=1400&s=1"
    ],
    vehicles: [
      { type: "Sedan", price: "₹12/km", image: "https://acecabs.in/cars/sedan/Honda-Amaze.png" },
      { type: "SUV", price: "₹16/km", image: "https://indorecabservice.com/wp-content/uploads/2022/03/maruti-ertiga-sport-small-removebg-preview.png" },
      { type: "Tempo Traveller", price: "₹22/km", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJIT1TTdA0jjKVtha6svcmP3ck8cu4xPIOhSxVdfzhVzQxF152G7B0NJXxFr_SEFMRpJM&usqp=CAU" }
    ],
    itinerary: [
      { day: "Day 1", detail: "Pickup from Hyderabad and drive to Vijayawada" },
      { day: "Day 1", detail: "Visit Kanaka Durga Temple & Prakasam Barrage" },
      { day: "Day 2", detail: "Return to Hyderabad" },
    ],
    highlights: [
      "✔️ Religious & cultural trip",
      "✔️ Comfortable road journey",
    ],
  },
};
